<template>
      <div class="yuliang" ref="yuliang">
        <div class="select">
          <!-- 类别 -->
          <div class="storageType" >
            <span class="desc">选择时间：</span>
            <el-date-picker v-model="selecttime1" :picker-options="Global.pickerOptionsStart(selecttime2)" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择开始时间" default-time="08:00:00">
            </el-date-picker>
            <span class="desc">至</span>
            <el-date-picker v-model="selecttime2" :picker-options="Global.pickerOptionsEnd(selecttime1)" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" type="datetime" placeholder="选择结束时间"  default-time="08:00:00">
            </el-date-picker>
          </div>
          <div>
            <span id="select" @click="tabledata">查询</span>
          </div>
          <div class="export">
             <span @click="exportdata" id="export"><span class="export-icon"></span>导出</span>
          </div>
        </div>
        <div class="raintable">
          <el-table v-loading="loading" :row-class-name="tableRowClassName" :data="tdata" :height="height" border style="width: 100%;" :default-sort ="{prop:'overflowWarningWater',order:'descending'}">
            <el-table-column fixed type="index" width="70" label="序号" align="center" header-align="center">
            </el-table-column>
            <el-table-column fixed="" prop="stlc" align="left" header-align="left" label="所在地" min-width="120">
            </el-table-column>
            <el-table-column fixed prop="stnm" align="left" header-align="left" label="水库名称" min-width="120">
            </el-table-column>
            <el-table-column   header-align="center" label="汛限" min-width="120" :sortable='true' :sort-method="sortChange1">
              <el-table-column prop="wrz" align="center" header-align="center" label="水位(m)" min-width="110" sortable>
              </el-table-column>
              <el-table-column prop="wrzStorage" align="center" header-align="center" label="库容(万m³)" min-width="130" :sortable='true' :sort-method="sortChange2">
              </el-table-column>
            </el-table-column>
            <el-table-column  align="center" header-align="center" :label="lable1" min-width="120" >
              <el-table-column prop="beginZ" align="center" header-align="center" label="水位(m)" min-width="110" sortable>
              </el-table-column>
              <el-table-column prop="beginStorage" align="center" header-align="center" label="库容(万m³)" min-width="130" :sortable='true' :sort-method="sortChange2">
              </el-table-column>
            </el-table-column>
            <el-table-column  align="center" header-align="center" :label="lable2" min-width="120" >
              <el-table-column prop="endZ" align="center" header-align="center" label="水位(m)" min-width="110" sortable>
              </el-table-column>
              <el-table-column prop="endStorage" align="center" header-align="center" label="库容(万m³)" min-width="130" :sortable='true' :sort-method="sortChange2">
              </el-table-column>
            </el-table-column>
            <el-table-column  align="center" header-align="center" label="过程最高水位" min-width="120"  >
              <el-table-column prop="maxZ" align="center" header-align="center" label="水位(m)" min-width="110" sortable>
              </el-table-column>
              <el-table-column prop="maxStorage" align="center" header-align="center" label="库容(万m³)" min-width="130" :sortable='true' :sort-method="sortChange2">
              </el-table-column>
              <el-table-column prop="maxTime" align="center" header-align="center" label="时间" min-width="150" >
              </el-table-column>
            </el-table-column>
            <el-table-column  align="center" header-align="center" label="过程最低水位" min-width="120"  >
              <el-table-column prop="minZ" align="center" header-align="center" label="水位(m)" min-width="110" sortable>
              </el-table-column>
              <el-table-column prop="minStorage" align="center" header-align="center" label="库容(万m³)" min-width="130" :sortable='true' :sort-method="sortChange2">
              </el-table-column>
              <el-table-column prop="minTime" align="center" header-align="center" label="时间" min-width="150">
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
</template>
<script>
import riverwatersituationTypes from '@/store/types/riverwatersituation'
import timer from '@/utils/timer'
export default {
  name: 'MonitoringCenter',
  data () {
    return {
      maxZ_Time: '',
      timerFun: '',
      lastestZ: '',
      maxZ: '',
      thestation: '',
      inputData: '',
      loading: true,
      loading1: true,
      height: 10,
      aDDVCD: '',
      stationName: '',
      isTown: true,
      searchName: '',
      tdata: [],
      all: true,
      adcdtotal: '',
      pageIndex: 1,
      pageSize: 100,
      towns: [],
      checkarr: [],
      dialogVisible: false,
      sTID: '',
      time: '',
      chartwaterValues: [],
      chartxline: [],
      chartwrZs: [],
      chartrainValues: [],
      datev: '',
      radio: '1',
      dateselect: true,
      sID: 22,
      myChart: {},
      reservoirType: '',
      storageType: '',
      seletdate: '',
      selecttime1: '',
      selecttime2: '',
      lable1: '',
      lable2: ''
    }
  },
  computed: {
  },
  methods: {
    // 列排序
    sortChange1 (a, b) {
      return a.waterAtEight - b.waterAtEight
    },
    sortChange2 (a, b) {
      return a.water - b.water
    },
    sortChange3 (a, b) {
      return a.warningWater - b.warningWater
    },
    sortChange4 (a, b) {
      return a.overflowWarningWater - b.overflowWarningWater
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.overflowWarningWater > 0) {
        console.log(row.overflowWarningWater)
        return 'warning-row'
      }
      return ''
    },
    tabledata () {
      this.loading = true
      this.$store.dispatch(riverwatersituationTypes.getReservoirWaterProcedure, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2,
        PageIndex: 1,
        PageSize: 500
      }).then(data => {
        this.tdata = data.results
        this.loading = false
      })
    },
    setListCheck: function (idx, adcd) {
      this.loading = true
      this.all = false
      var check = this.towns[idx].check
      this.towns[idx].check = !check
      let checknum = this.thecheck()
      this.addcheckarr(adcd, this.towns[idx].check)
      // console.log(adcd, this.towns[idx].check)
      // 拼接截取
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.aDDVCD = ''
        this.checkarr.forEach((item) => {
          this.aDDVCD += item.substring(0, 9) + ','
        })
        this.aDDVCD = this.aDDVCD.substring(0, this.aDDVCD.length - 1)
        this.tabledata()
      }
      // 0或全选 变为全部
      if (checknum === this.adcdtotal || checknum === 0) {
        this.setAllCheck()
      }
    },
    addcheckarr: function (adcd, state) {
      console.log(adcd, state)
      if (state) {
        this.checkarr.push(adcd)
      } else {
        this.deletecheckarr(adcd)
      }
    },
    deletecheckarr: function (adcd) {
      if (this.checkarr !== undefined && this.checkarr.length !== 0) {
        this.checkarr.forEach((item, index) => {
          if (item === adcd) {
            this.checkarr.splice(index, 1)
          }
        })
      }
    },
    setAllCheck: function () {
      this.all = true
      this.checkarr = []
      this.aDDVCD = ''
      this.towns.forEach((item) => {
        item.check = false
      })
      this.tabledata()
    },
    thecheck: function () {
      let num = 0
      this.towns.forEach((item) => {
        if (item.check) {
          num++
        }
      })
      return num
    },
    // 数据排序
    dataSort (type, sortData) {
      this.sortType = type
      sortData.sort(this.compare(type))
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val2 - val1
      }
    },
    exportdata () {
      this.$store.dispatch(riverwatersituationTypes.exportReservoirWaterProcedure, {
        sID: this.sID,
        BeginDate: this.selecttime1,
        EndDate: this.selecttime2
      }).then(data => {
        let blob = new Blob([data])
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '水库水位过程.xls'
        link.click()
        link.remove()
      })
    },
    getTime () {
      var date = new Date()
      var preDate = new Date(date.getTime() - 24 * 60 * 60 * 1000)
      // 年
      // var year = date.getFullYear()
      // 月
      var month = date.getMonth() + 1
      // 日
      var day = date.getDate()
      var hour = date.getHours()
      if (hour < 8) { // 当前时间在8:00之前
        this.selecttime1 = this.$moment(preDate).format('YYYY-MM-DD 08:00')
        // this.selecttime1 = new Date(year, month - 1, day - 1, 8, 0)
      } else {
        this.selecttime1 = this.$moment(date).format('YYYY-MM-DD 08:00')
        // this.selecttime1 = new Date(year, month - 1, day, 8, 0)
      }
      this.selecttime2 = this.$moment(date).format('YYYY-MM-DD HH:00')
      // this.selecttime2 = new Date(year, month - 1, day, hour, 0)
      this.lable1 = month + '月' + day + '日' + 8 + '时'
      this.lable2 = month + '月' + day + '日' + hour + '时'
    }
  },
  mounted () {
    this.getTime()
    this.tabledata()
    this.timerFun = setInterval(() => {
      this.getTime()
      this.tabledata()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      let countryListDiv = document.getElementsByClassName('countryList')
      this.$refs['yuliang'].style.height = (contentDiv[0].offsetHeight - countryListDiv[0].offsetHeight - 45) + 'px'
      let selectDiv = document.getElementsByClassName('select')
      this.height = this.$refs['yuliang'].offsetHeight - selectDiv[0].offsetHeight - 20
    })
  },
  beforeDestroy () {
    clearInterval(this.timerFun)
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped></style>
<style lang="less" scoped>
.monitor{
  .content{
    .yuliang{
      .select{
        display: flex;
        position: relative;
        .el-input{
          width: 165px;
        }
        .export {
          position: absolute;
          right: 0;
        }
        div.storageType{
          display: flex;
          position: relative;
          bottom: 8px;
          div{
            width:220px;
          }
        }
      }
    }
  }
}
// 样式穿透
.content /deep/ .yuliang .raintable .el-table .warning-row{
  background:#f3f364 !important;
}
#station{
  width: 100%;
  height: 400px;
}
.block{
  position: absolute;
  width: 95%;
  top: 15px;
  left: 0;
  text-align: center;
}
.chartshuiwei{
    text-align: center;
    width: 100%;
    // text-align: center;
  }
</style>
